<template>
  <v-container fluid py-0 px-0 id="order-add-edit">
    <u-i-toolbar-admin :title="titlePage" :icon="icon"/>
    <v-layout align-center pt-3 fill-height>
      <v-flex xs12>
        <v-flex
          v-for="(bag, bagKey) in bags"
          :key="bagKey"
          xs12
          pb-4
        >
          <v-layout align-top py-0 px-2 row wrap>
            <v-flex d-flex xs12 sm6 class="header-block-left">
              <v-flex d-flex xs12 sm3>
                <v-layout row wrap>
                  <v-flex d-flex xs12>
                    <v-img
                      :src="require('@/assets/h4b_logo_big.png')"
                      :contain="true"
                      class="bags-list--logo"
                      min-width="175px"
                      max-width="175px"
                      width="175px"
                      alt="logo"
                    />
                  </v-flex>
                  <v-flex d-flex xs12 class="grey--text text--darken-1 align-items-flex-end">
                    Sender Branch: {{ officeAddress.company_name }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex xs12 sm8 pl-3>
                <v-layout row wrap class="font-weight-medium" style="line-height: 1.2">
                  {{ officeAddress.company_name }}
                  <br>
                  {{ officeAddress.address }}, {{ officeAddress.city }}
                  <br>
                  {{ $helpers.getProp(officeAddress, 'country.title', '') }},
                  {{ officeAddress.zip }}
                  <br>
                  {{ officeAddress.phone }}
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex d-flex xs12 sm6>
              <v-flex d-flex xs12 sm10 pr-2>
                <v-layout row wrap>
                  <v-flex d-flex xs12>
                    <strong class="text-xs-right">
                      MNS 5380-2 : 2004
                    </strong>
                  </v-flex>
                  <v-flex d-flex xs12 class="align-items-flex-end">
                    <span class="text-xs-right mr-4 grey--text text--darken-1">
                      Receiver Organization: MT Online Express
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex xs12 sm3 md2 child-flex>
                <div class="box-number">
                  {{ $helpers.getProp(bag, 'shipment_method_name', '').charAt(0).toUpperCase() }}{{ bag.position }}
                </div>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout align-top pt-3>


            <v-flex xs12 sm12 py-0 px-2>
              <v-data-table
                :headers="headers"
                :items="bag.orders"
                :hide-actions="true"
                class="box-table-orders"
                disable-initial-sort
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="(header, key) in props.headers"
                      :key="key"
                      :class="header.class"
                      :colspan="header.colspan"
                      class="text-xs-center"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td class="text-xs-center blue--text text--darken-4" colspan="2">{{ props.index + 1 }}</td>
                  <td class="text-xs-center blue--text text--darken-4">{{ props.item.tracking_number_internal }}</td>
                  <td class="text-xs-center blue--text text--darken-4">{{ props.item.package_weight }}</td>
                  <td class="text-xs-center blue--text text--darken-4">
                    {{ props.item.country }}, {{ props.item.recipient_name }}
                  </td>
                  <td class="text-xs-center blue--text text--darken-4">{{ bag.name }}</td>
                  <td class="text-xs-center blue--text text--darken-4"></td>
                </template>
                <template v-slot:footer>
                  <tr>
                    <th
                      class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2"
                      colspan="3"
                    >
                      Total / International / Domestic
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Weight
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Receive
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Swap
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Total Pieces
                    </th>
                  </tr>
                  <tr>
                    <td class="text-xs-center blue--text text--darken-4">{{ bag.total }}</td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4">{{ bag.total }}</td>
                    <td class="text-xs-center blue--text text--darken-4">{{ bag.weight_sum }}</td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                  </tr>
                  <tr>
                    <th colspan="3"></th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Name
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Signature
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Date
                    </th>
                    <th class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2">
                      Time
                    </th>
                  </tr>
                  <tr>
                    <th
                      colspan="3"
                      class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2"
                    >
                      Prepared by
                    </th>
                    <td class="text-xs-center blue--text text--darken-4">{{ officeAddress.company_name }}</td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                  </tr>
                  <tr>
                    <th
                      colspan="3"
                      class="text-xs-center font-weight-bold blue lighten-3 blue--text text--darken-4 body-2"
                    >
                      Received by
                    </th>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                    <td class="text-xs-center blue--text text--darken-4"></td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs12 text-xs-left>
            <v-btn
              color="info"
              class="text-none"
              round
              :fab="$vuetify.breakpoint.smAndDown"
              :small="$vuetify.breakpoint.smAndDown"
              @click="onPrint"
            >
              <v-icon
                color="white"
                :class="$vuetify.breakpoint.mdAndUp ? 'v-icon--left' : 'v-icon--center d-flex'"
                class="mr-2"
                dark small
              >fa-solid fa-lg fa-print
              </v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp">Print</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import ReportsFlightsService from '@/services/Admin/ReportsFlights';

export default {
  name: 'ConsolidatedInvoice',
  props: {
    id: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    UIToolbarAdmin
  },
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  data: () => ({
    formData: {},
    isForm: true,
    headers: [
      {
        text: '',
        colspan: 2,
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2'
      },
      {
        text: 'Tracking',
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2'
      },
      {
        text: 'Weight',
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2',
      },
      {
        text: 'Where, Who (consignee)',
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2',
      },
      {
        text: 'Bag #',
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2',
      },
      {
        text: 'Comments',
        class: 'font-weight-bold blue lighten-3 blue--text text--darken-4 body-2',
      }
    ]
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getBagsList(this.$route.params.id)
        .then(response => {
          this.formData = this.$helpers.getProp(response, 'data', {});
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    onPrint() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getBagsListPdf(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$store.dispatch('setError', error.response.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    }
  },
  computed: {
    bags() {
      return this.$helpers.getProp(this.formData, 'data', []).sort((a, b) => +a.position < +b.position ? 1 : -1);
    },
    officeAddress() {
      return this.$helpers.getProp(this.formData, 'office_address', {});
    },
    titlePage() {
      return 'Bags List';
    },
    icon() {
      return 'cases';
    }
  }
}
</script>

<style lang="stylus">
.align-items-flex-end {
  align-items: flex-end;
}

.header-block-left {
  @media (max-width: 600px) {
    margin-bottom: 24px;
  }
}

.bags-list--logo {
  @media (max-width: 1440px) {
    max-width: 100% !important;
    min-width: auto !important;
  }
}

.box-table-orders {
  table {
    background: none;
    border-spacing: 4px;
    border-collapse: unset;
    border: none !important;
    box-shadow: none !important;

    thead tr:not(.v-datatable__progress), tbody td, tfoot tr {
      height: 32px !important;
    }

    tbody tr {
      background: none !important;
    }

    th, td {
      border-radius: 15px;
    }

    td {
      border: 1px solid #90caf9 !important;

      &.empty {
        border: none !important;
      }
    }

    th, tr {
      border: none !important;
      box-shadow: none !important;
    }
  }
}

.box-number {
  width: 90px;
  max-width: 90px;
  min-width: 90px;
  height: 90px;
  max-height: 90px;
  min-height: 90px;
  line-height: 68px;
  padding: 8px;
  text-align: center;
  border: 2px solid #264bdd;
  border-radius: 25px;
  font-size: 44px;
  font-weight: 900;
  color: #264bdd;
  margin: 0 auto;

  @media (max-width: 960px) and (min-width: 600px) {
    width: 100%;
    min-width: max-content;
    max-width: 100%;
    height: auto;
    max-height: max-content;
    min-height: auto;
    line-height: normal;
  }
}
</style>
